import { SerializableObject } from '../../common-react/core';

import { Currency } from '../other/currency.type';

import { CashOnDeliveryInfo } from './cash-on-delivery-info.do';

export class ShipmentOptions extends SerializableObject {
  /**
   * The recipient will pay all fees for the shipment.
   */
  public recipientPaysShippingFee: boolean;
  /**
   * Mark shipments as fragile to make sure the parcels will be handled with extra care.
   */
  public fragile: boolean;
  /**
   * Express delivery of the shipment.
   */
  public express: boolean;
  /**
   * Written confirmation that the recipient has received the shipment. The notification of delivery, signed by the
   * recipient and the mail delivery person delivering the shipment, is returned to the sender after the shipment has
   * been delivered.
   */
  public deliveryAdvice: boolean;
  /**
   * The shipment will only be delivered to the registered recipient, i.e. no other party is allowed to receive the
   * shipment on behalf of the registered recipient.
   */
  public deliverToRecipientOnly: boolean;
  /**
   * Shipment will be delivered at the recipient address.
   */
  public homeDelivery: boolean;
  /**
   * Insurance amount for the shipment. If insurance amount is 0, then no insurance has been purchased for the Shipment.
   */
  public insuranceAmount: number;
  /**
   * Currency of the Insurance amount.
   */
  public insuranceCurrency: Currency;

  public cashOnDelivery: CashOnDeliveryInfo;
}
